import { NestedLink } from '@/graphql/gql/graphql';
import Link from 'next/link';
import Image from '@/components/Image';
import { useCallback } from 'react';
import { useAmplitude } from '@/utils/hooks/useAmplitude';
import { NAV_LINK_CLICKED } from '@/constants/amplitude';
import Styles from './SportSubMenu.module.scss';

interface SportSubMenuProps {
  submenu: NestedLink;
  more?: boolean;
  hide: () => void;
}
const SportSubMenu = ({ submenu, more, hide }: SportSubMenuProps) => {
  const getLink = useCallback((url: string) => (url.includes('http') ? url : `https://www.fanduel.com/research${url}`), []);
  const { logAmplitudeEvent } = useAmplitude();
  return (
    <div className={Styles.container}>
      <div className={Styles.menu}>
        <p className={Styles.title}>
          {more ? submenu.text : `Explore ${submenu.text}`}
        </p>
        <ul className={more ? Styles.more : ''}>
          {submenu.children?.map((menuItem) => (
            <li key={menuItem?.text}>
              <Link
                onClick={() => {
                  hide();
                  logAmplitudeEvent(
                    NAV_LINK_CLICKED,
                    {
                      'Link Text': menuItem?.text ?? '',
                      'Link URL': menuItem?.url ?? '',
                      Module: 'navigation_menu',
                      Menu: submenu.text,
                    },
                  );
                }}
                href={getLink(menuItem?.url ?? '')}
              >
                <span>
                  {menuItem?.iconUrl
                    ? <Image width={16} height={16} src={menuItem.iconUrl} alt={`${menuItem.text} icon`} />
                    : ''}
                  {menuItem?.text}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default SportSubMenu;
